// ------------------------------------
// Exibe/Oculta itens do pedido
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $btnToggle = $('.co-resume-btn-toggle');
  const $resumeItens = $('.co-resume-items-body');
  const $keepBuy = $('.co-resume-keep-buy');
  const $coupon = $('.co-resume-coupon');
  const $resumeValues = $('.co-resume-values li:not(.dest)');

  // Ao clicar no botão
  $btnToggle.on('click', function (ev) {
    ev.preventDefault();
    if (!$btnToggle.hasClass('active') || $btnToggle.hasClass('toggle-hide-mb')) {
      showResume();
    } else {
      hideResume();
    }
  });

  function showResume() {
    $btnToggle.addClass('active');
    $btnToggle.removeClass('toggle-hide-mb');
    //$btnToggle.find('span').text('Ocultar itens');
    $resumeItens.removeClass('hide-mb').slideDown();
    $resumeValues.removeClass('hide-mb').slideDown();
    if ($keepBuy.length > 0) {
      $keepBuy.removeClass('hide-mb').slideDown();
    }
    if ($coupon.length > 0) {
      $coupon.removeClass('hide-mb').slideDown();
    }
    /* if ($('.v-cart-total.show-parc').length) {
      $('.v-cart-total.show-parc').removeClass('hide-parc');
    } */
  }
  $btnToggle.on('show-resume', showResume);

  function hideResume() {
    $btnToggle.removeClass('active');
    $btnToggle.removeClass('toggle-hide-mb');
    //$btnToggle.find('span').text('Exibir itens');
    $resumeItens.slideUp();
    $resumeValues.slideUp();
    if ($keepBuy.length > 0) {
      $keepBuy.slideUp();
    }
    if ($coupon.length > 0) {
      $coupon.slideUp();
    }
    /* if ($('.v-cart-total.show-parc').length) {
      $('.v-cart-total.show-parc').addClass('hide-parc');
    } */
  }
  $btnToggle.on('hide-resume', hideResume);
})();

// ------------------------------------
// Altera a quantidade dos itens do carrinho
// ------------------------------------
(function () {
  'use strict';

  // Evento ao alterar a quantidade
  $('body').on('change', '.ns-input', function (ev) {
    ev.preventDefault();
    if (!previewMode) {
      const product = $(this).data('prod');
      const quantity = $(this).val();
      if (product && quantity && quantity > 0) {
        const data = {
          product: product,
          quantity: quantity,
        };
        $('.shipping-quantity-loader').show();
        showLoader('Por favor, aguarde...');
        console.log('Save from: cart_item qty change');
        saveCheckout(
          'save_qtdy',
          data,
          function () {
            $('#co-card-installments').val('');
            window.location.reload();
            /* $('#co-zipcode').trigger('change-quantity');
            if ($('#co-coupon').length && $('#co-coupon').val() != '') {
              $('.btn-coupon').trigger('click');
            }
            calcCheckout(); */
          },
          '.shipping-quantity-loader',
        );
        setTimeout(() => {
          hideLoader();
          //window.location.reload();
        }, 3000);
      }
    }
  });
})();

// ------------------------------------
// Remove um item do carrinho
// ------------------------------------
(function () {
  'use strict';

  // Evento ao remover um item
  $('body').on('click', '.remove-item', function (ev) {
    ev.preventDefault();
    if (!previewMode) {
      const $el = $(this);
      const $elItem = $el.closest('.co-r-item');
      const cartItemID = $el.data('item-cart');
      if (cartItemID) {
        const cartItemsRem = [];
        cartItemsRem.push(cartItemID);
        // Verifica se também tem order bump para remover
        if ($('.co-r-item-orderbump').length > 0) {
          $('.co-r-item-orderbump .btn-ob-act').each(function () {
            cartItemsRem.push($(this).data('item-cart'));
          });
        }
        const data = {
          cart_item: cartItemsRem.join(','),
        };
        $('.shipping-quantity-loader').show();
        console.log('Save from: cart_item remove');
        saveCheckout(
          'remove_item',
          data,
          function () {
            window.location.reload();
            /* $elItem.remove();
            $('#co-zipcode').trigger('change-quantity');
            calcCheckout();
            if ($('.co-r-item:not(.co-r-item-orderbump)').length === 0) {
              window.location.reload();
            }
            if ($('.co-r-item.co-r-item-orderbump').length > 0) {
              $('body').trigger('ob-rem-all');
            } */
          },
          '.shipping-quantity-loader',
        );
      }
    }
  });
})();
